import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { formatInTimeZone, getTimezoneOffset } from 'date-fns-tz';
import { zoneFor } from '@components/ui/timezone/timezoneMappings';

export const exportLiveTrackToExcel = async ( ltData, jobData ) => {
    if (!ltData || ltData.length === 0) return;

    const { jobName, runName, tz } = jobData;
    const launchDate = ltData[0].PassTime ?? null;

    // runs launched before 2026-03-08 keep the DST offset Alberta and BC used at the time
    const zone = zoneFor(tz, launchDate);

    let runDate;
    if(launchDate) {
        runDate = formatInTimeZone(new Date(launchDate), zone, 'yyyy-MM-dd');
    }

    // offset in milliseconds
    const offsetMs = getTimezoneOffset(zone, new Date(launchDate));

    // convert to hours
    const offsetHours = offsetMs / (1000 * 60 * 60);

    //create workbook
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Live Track Data');

    worksheet.getCell('A1').value = jobName;
    worksheet.getCell('A2').value = runName;
    worksheet.getCell('A3').value = offsetHours;

    worksheet.getRow(5).values = [
        'Site_Name',
        'Pass_Time',
        'Est_Pass_Time',
        'Real_Chain_km',
        'Speed_kmh',
        'Time_To_mins',
        'Passage_Notes',
        'Box_Number',
        'Site_Notes'
    ];

    worksheet.columns = [
        { key: 'Site_Name', width: 15 },
        { key: 'Pass_Time', width: 25 },
        { key: 'Est_Pass_Time', width: 25 },
        { key: 'Real_Chain_km', width: 15 },
        { key: 'Speed_kmh', width: 12 },
        { key: 'Time_To_mins', width: 14 },
        { key: 'Passage_Notes', width: 20 },
        { key: 'Box_Number', width: 12 },
        { key: 'Site_Notes', width: 20 }
    ];

    //format row data - editedData is already flattened (no AGMs[0] nesting)
    const rowData = ltData.map((r) => {
        return {
            Site_Name: r.Site_Name ?? '',
            Pass_Time: r.PassTime ?? '',
            Est_Pass_Time: r.Est_PassTime ?? '',
            Real_Chain_km: r.Real_Chain ?? '',
            Speed_kmh: r.Speed ?? '',
            Time_To_mins: r.timeTo ?? '',
            Passage_Notes: r.Pass_Notes ?? '',
            Box_Number: r.Box_Number ?? '',
            Site_Notes: r.Site_Notes ?? ''
        }
    });

    //add rows
    worksheet.addRows(rowData, 'i+');

    //buffer
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), `${runDate}_${jobName}_${runName}_liveTrack.xlsx`);
}